const INVOICE_CONTACT = {
  _id: "",
  id: "",
  name: "",
  email: "",
  address1: "",
  address2: "",
  city: "",
  state: "",
  zip: "",
};

const ASSET = {
  id: "",
  asset_serial: "",
};

const TICKET = {
  id: "",
  _id: "",
  number: "",
  subject: "",
  customer_business_then_name: "",
  problem_type: "",
  status: "",
  created_at: "",
  updated_at: "",
  resolved_at: "",
  received_at: "",
  contact: null,
  invoice_contacts: [INVOICE_CONTACT],
  assets: [ASSET],
};

const CHANGE_HANDLERS = {
  handleChange: () => {},
  handleSearch: () => {},
};

const GetTicketFormProps = ({
  formObject = TICKET,
  changeHandlers = CHANGE_HANDLERS,
}) => {
  const {
    _id,
    id,
    number,
    subject,
    customer_business_then_name,
    problem_type,
    status,
    created_at,
    updated_at,
    resolved_at,
    received_at,
    invoice_contacts,
    assets,
    contact,
  } = formObject;

  const { handleChange, handleSearch } = changeHandlers;

  const effectiveInvoiceContacts =
    Array.isArray(invoice_contacts) && invoice_contacts.length > 0
      ? invoice_contacts
      : contact
      ? [
          {
            id: contact.id || "",
            name: contact.name || "",
            email: contact.email || "",
            address1: contact.address1 || "",
            address2: contact.address2 || "",
            city: contact.city || "",
            state: contact.state || "",
            zip: contact.zip || "",
          },
        ]
      : [];

  return {
    number: {
      type: "link",
      props: {
        "data-id": _id,
        label: "Number",
        text: number,
        name: "number",
        className: "w-96",
        link: `https://techcyclesolutions.repairshopr.com/tickets/${id}`,
      },
    },
    subject: {
      type: "text",
      props: {
        "data-id": _id,
        label: "Subject",
        value: subject,
        name: "subject",
        onChange: handleChange,
        className: "w-96",
      },
    },
    customer_business_then_name: {
      type: "text",
      props: {
        "data-id": _id,
        label: "Customer Name",
        value: customer_business_then_name,
        name: "customer_business_then_name",
        readOnly: true,
        handleSearch: handleSearch,
        className: "w-96",
        search: true,
      },
    },
    invoice_contacts: {
      type: "multiSelect",
      props: {
        label: "Invoice Contacts",
        name: "invoice_contacts",
        value: effectiveInvoiceContacts,
        childValue: "name",
        searchValue: "name",
        parentId: _id,
        multiple: true,
        options: [],
        search: true,
        handleSearch: handleSearch,
        onChange: () => {}, // TODO: Change to OnRemove
        handleCopyClilck: () => {}, // TODO: Implement handleCopyClick
      },
    },
    status: {
      type: "text",
      props: {
        "data-id": _id,
        label: "Status",
        value: status,
        name: "status",
        onChange: handleChange,
        className: "w-96",
      },
    },
    assets: {
      type: "multiSelect",
      props: {
        label: "Asset Serial",
        name: "assets",
        value: assets,
        childValue: "asset_serial",
        searchValue: "asset_serial",
        parentId: _id,
        multiple: true,
        options: [],
        search: false,
        handleSearch: handleSearch,
        onChange: () => {}, // TODO: Change to OnRemove
        handleCopyClilck: () => {}, // TODO: Implement handleCopyClick
      },
    },
    problem_type: {
      type: "text",
      props: {
        "data-id": _id,
        label: "Problem Type",
        value: problem_type,
        name: "problem_type",
        onChange: handleChange,
        className: "w-96",
      },
    },

    created_at: {
      type: "datetime",
      props: {
        "data-id": _id,
        label: "Created",
        value: created_at,
        name: "created_at",
        onChange: handleChange,
        className: "w-96",
      },
    },
    updated_at: {
      type: "datetime",
      props: {
        "data-id": _id,
        label: "Updated",
        value: updated_at,
        name: "updated_at",
        onChange: handleChange,
        className: "w-96",
      },
    },
    // resolved_at: {
    //   type: "date",
    //   props: {
    //     "data-id": _id,
    //     label: "Resolved",
    //     value: resolved_at,
    //     name: "resolved_at",
    //     onChange: handleChange,
    //     className: "w-96",
    //   },
    // },
    // received_at: {
    //   type: "date",
    //   props: {
    //     "data-id": _id,
    //     label: "Received",
    //     value: received_at,
    //     name: "received_at",
    //     onChange: handleChange,
    //     className: "w-96",
    //   },
    // },
  };
};

export default GetTicketFormProps;
